import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { firstValueFrom, of, Subject, Subscription, takeUntil } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { BusLookupService } from '@core/services/bus-lookup.service';
import { busLookupsModuleCode, lookupStatus } from '@core/enums/bus-Lookup';
import { TicketGridViewType } from '@core/enums/ticket-grid-view';
import { BusLookup } from '@core/model/bus-lookup/bus-lookup';
import { PageFilter } from '@core/model/pagination/filter';
import { PageResult } from '@core/model/pagination/page-result';
import { SortEnumType, TicketStatusChange } from '@generated/queries';
import { FetchPolicy } from '@apollo/client/core';
import { AppPermissions } from '@core/app.config';
import { UserService } from '@shared/services/user.service';
import { LaborRateType } from '@core/enums/ticket-labor';
import { User } from '@core/model/user/user';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ResourceType, ResourceTypeNames } from '@core/enums/resource.enum';
import { AppUtilService } from '@shared/services/app-util.service';
import {
  Ticket,
  UpdateTicketOrder,
} from '../../../app/layout/pages/tickets/models/tickets';
import { CommunicationService } from '../../../app/layout/pages/tickets/services/communication.service';
import { TicketsService } from '../../../app/layout/pages/tickets/services/tickets.service';
import { SharedParamsService } from '../../../app/layout/pages/tickets/services/shared-params.service';
import { TktSiteService } from '../../../app/layout/pages/tickets/services/tkt-site.service';
import { ConvertDateUtcTimezoneService } from '@shared/services/convert-date-utc-timezone.service';
import { TicketLabourService } from '../../../app/layout/pages/tickets/services/ticket-labour.service';
import { TicketStatusChangeService } from '../../../app/layout/pages/tickets/services/ticket-status-change.service';
import { TicketDetailPopupComponent } from '../../../app/layout/pages/tickets/components/ticket-detail-popup/ticket-detail-popup.component';
import { TicketLabor } from '../../../app/layout/pages/tickets/models/ticket-labor';
import { TicketsStatusChange } from '../../../app/layout/pages/tickets/models/ticket-status-change';
import { DateRangeUtilService } from '@shared/services/date-range-util.service';
import { DropdownToggleService } from '@shared/services/dropdown-toggle.service';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { SiteType } from '@core/enums/tktSite-enum';
import { Site } from '../../../app/layout/pages/tickets/models/tkt-site';
import moment from 'moment';
import { ResourceBoardType } from '@shared/enums/resource-board-type';

@Component({
  selector: 'app-resource-board',
  standalone: false,
  templateUrl: './resource-board.component.html',
  styleUrls: ['./resource-board.component.css'],
  animations: [
    trigger('expandCollapse', [
      state(
        'expanded',
        style({
          height: '*',
          opacity: 1,
          padding: '*',
        })
      ),
      state(
        'collapsed',
        style({
          height: '0px',
          opacity: 0,
          padding: '0',
        })
      ),
      transition('expanded <=> collapsed', [animate('500ms ease')]),
    ]),
  ],
})
export class ResourceBoardComponent implements OnInit, OnDestroy {
  @ViewChild(DaterangepickerDirective)
  datePickerDirective: DaterangepickerDirective;
  @ViewChild('startPicker', { read: DaterangepickerDirective })
startPicker!: DaterangepickerDirective;

@ViewChild('duePicker', { read: DaterangepickerDirective })
duePicker!: DaterangepickerDirective;
  @Input() dynamicHeight = false;
  @Input() dropdownOpen = true;
  @Input() profileCardHeight : string = 'max-h-[calc(100vh-230px)]';

  @Input() newDates: { day: string; date: string }[] = [];
  @Input() statusListAll = [];
  /* eslint-disable */
  Users: any[] = [];
  UserTickets: any[] = [];
  FilteredUserTickets: any[] = [];
  ShowTickets: any[] = [];
  allTickets: any[] = [];
  userAllTickets: any[] = [];
  filteredUserTicketsByCount: any[] = [];
  searchResourceByName = '';
  /* eslint-enable */
  weekDays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];

  countTickets: PageResult<Ticket> = new PageResult<Ticket>();
  hourTickets: PageResult<Ticket> = new PageResult<Ticket>();

  @ViewChildren('carouselRefs') carouselRefs!: QueryList<ElementRef>;

  filters: PageFilter = {
    pageIndex: 0,
    activeIndex: 1,
    take: 500,
    search: '',
    state: '',
  };

  // eslint-disable-next-line
  params: any;
  isDialogOpened: boolean;
  statusList: BusLookup[] = [];
  loading = true;
  statusIdsList: string[];
  userResourceFilter: ResourceType = ResourceType.ALL;
  workerId: string;
  siteSearch = '';
  statusSearch = [];
  prioritySearch = '';
  ProblemSearch = '';
  facilitySearch = '';
  areaSearch = '';
  locationAreaSearch = '';
  lastLocationAreaSearch = '';
  resourceView = '';
  sortInput: { entryDate: SortEnumType } = { entryDate: SortEnumType.Desc };
  startDate: string;
  endDate: string;
  startEntryDate: string;
  endEntryDate: string;
  isManager = false;
  timeZone = 'UTC+05:00';
  lookupModuleCOde = busLookupsModuleCode.TktStatus;
  private destroy$ = new Subject<void>();
  ticketGridViewType = TicketGridViewType;
  ticketGridView: TicketGridViewType;

  ViewAllTicketsRead;
  ViewAllTicketsWrite;
  //
  TicketResourcesBoardRead;
  TicketResourcesBoardWrite;
  //

  expandedItems: boolean[] = [];
  allExpanded = false;
  private subscription: Subscription;
  // eslint-disable-next-line
  dueDate: any;
  // eslint-disable-next-line
  entryDate: any;
  dateLocale = {
    format: 'MM/DD/YYYY', // → e.g., May 2, 2025
  };
  // eslint-disable-next-line
  ranges: any = {};
  rangesEntry: any = {};
  options = [
    { id: ResourceType.ALL, name: ResourceTypeNames[ResourceType.ALL] },
    { id: ResourceType.PRIMARY, name: ResourceTypeNames[ResourceType.PRIMARY] },
    {
      id: ResourceType.SECONDARY,
      name: ResourceTypeNames[ResourceType.SECONDARY],
    },
  ];
  selectedOption: ResourceType = ResourceType.ALL;
  siteType = SiteType.LOCATION;
  facilityType = SiteType.FACILITY;
  areaType = SiteType.AREA;
  selectedSiteType = SiteType.FACILITY;

  stSearch: string[] = [];
  fcSearch: string[] = [];
  isCallLocationRefresh = false;
  isCallAreaRefresh = false;
  siteSortInput: Record<string, SortEnumType> = { siteName: SortEnumType.Asc };
  problemListAll = [];
  busLookupCodeProblem = busLookupsModuleCode.Problem;
  busLookupCodePriority = busLookupsModuleCode.Priority;
  problemList: BusLookup[] = [];
  ticketLocationsMap: Record<string, { location: Site; areas: Site[] }[]> = {};
  siteList: Site[] = [];
  boardType = ResourceBoardType;
  selectedBoardType: number;
isClearStatusFilters = false;

  constructor(
    private communicationService: CommunicationService,
    private service: TicketsService,
    private authService: AuthService,
    public busService: BusLookupService,
    private sharedParams: SharedParamsService,
    private activatedRoute: ActivatedRoute, // Remove duplicate
    public siteService: TktSiteService,
    private route: ActivatedRoute, // Keep only one ActivatedRoute
    private dialog: MatDialog,
    private router: Router,
    private uService: UserService,
    private utcTimeZone: ConvertDateUtcTimezoneService,
    private laborService: TicketLabourService,
    private statusChangeService: TicketStatusChangeService,
    public appUtilService: AppUtilService,
    public utcToTimeZone: ConvertDateUtcTimezoneService,
    private dateRangeUtilService: DateRangeUtilService,
    protected dropdownService: DropdownToggleService,
    private cdr: ChangeDetectorRef
  ) {
    this.ticketGridView = this.ticketGridViewType.LOCATION;

    // Add takeUntil to all subscriptions
    this.sharedParams.functionCalled$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (this.sharedParams.isComponentLoaded) {
          this.getSharedFilterValues(data);
        }
      });

    this.sharedParams.userResourceValue
      .pipe(takeUntil(this.destroy$)) // Add this
      .subscribe((value) => {
        this.userResourceFilter = value;
        this.clearData();
        this.resourceCountTickets();
      });

    this.ticketGridView = this.ticketGridViewType.BYTICKETCOUNT;

    // Fix duplicate ActivatedRoute usage and add takeUntil
    this.route.queryParamMap // Use route instead of activatedRoute
      .pipe(takeUntil(this.destroy$)) // Add this
      .subscribe((param) => {
        if (
          this.ticketGridView == this.ticketGridViewType.BYTICKETCOUNT ||
          this.ticketGridView == this.ticketGridViewType.BYHOURSCAPACITY
        ) {
          if (param.has('id') && !this.isDialogOpened) {
            this.ticketDetail(param.get('id'));
          }
        }
      });

    const timeZone = localStorage.getItem('timeZones');
    if (timeZone) {
      const parsedTimeZone = JSON.parse(timeZone);
      this.timeZone = parsedTimeZone[0];
    }
  }

  // eslint-disable-next-line
  async getSharedFilterValues(data: any) {
    if (this.isDialogOpened) {
      return;
    }

    if (this.selectedBoardType == this.boardType.TicketsResourceBoard) {
      if (data != null) {
        this.facilitySearch = this.sharedParams.facilitySearch;
        this.siteSearch = this.sharedParams.siteSearch;
        this.areaSearch = this.sharedParams.areaSearch;
        this.prioritySearch = this.sharedParams.prioritySearch;
        this.ProblemSearch = this.sharedParams.ProblemSearch;
        this.statusSearch = this.sharedParams.statusSearch;
        this.filters.pageIndex = 0;
        this.filters.activeIndex = 1;
        this.filters.search = this.sharedParams.ticketNoSearch;
        this.ticketGridView = this.ticketGridViewType.TICKET;
        //Due Date
        this.startDate = this.sharedParams.startDateSearch;
        this.endDate = this.sharedParams.endDateSearch;
        // Entry Date

        this.startEntryDate = this.sharedParams.startEntryDateSearch;
        this.endEntryDate = this.sharedParams.endEntryDateSearch;
      }
      if (!this.startDate || !this.endDate) {
        //Due Date
        this.startDate = this.dueDate?.startDate;
        this.endDate = this.dueDate?.endDate;
        //Entry Date
        this.startEntryDate = this.entryDate?.startDate;
        this.endEntryDate = this.entryDate?.endDate;
      }

      if (this.sharedParams.statusList.length > 0) {
        this.statusList = this.sharedParams.statusList;

        this.statusIdsList = this.statusList
          .map((parent) =>
            parent.childLookup
              ? parent.childLookup
                  .filter(
                    (child) =>
                      child.code === lookupStatus.CANCEL ||
                      child.code === lookupStatus.HOLD
                  )
                  .map((child) => child.id)
              : []
          )
          .reduce((acc, val) => acc.concat(val), []);

        this.statusSearch = this.statusSearch.filter(
          (id) => !this.statusIdsList.includes(id)
        );
      }
    }
     this.sharedParams.statusList = this.statusList;
     this.route.queryParams.subscribe((params) => {
      if (params['view'] !== 'by-mainboard') {
             this.isClearStatusFilters = this.sharedParams.isClearStatusFilters? this.sharedParams.isClearStatusFilters: this.isClearStatusFilters;
      }
    });
      if(this.statusSearch.length == 0 && !this.isClearStatusFilters){

        this.statusIdsList = this.getStstusListWithoutComplete();
        this.statusSearch = this.statusIdsList?.length>0? this.statusIdsList: this.statusSearch;
      }
      else{

        // this.statusSearch = this.statusSearch.filter(
        //         (id) => !this.statusIdsList.includes(id)
        //       );
      }
    this.loading = true;
    await this.LoadData(); // Wait for LoadData completely
    this.loading = false;
  }

  async ngOnInit() {
    if (this.router.url.includes('ticket')) {
      this.selectedBoardType = this.boardType.TicketsResourceBoard;
    }
    if (!this.dynamicHeight)
      this.selectedBoardType = this.boardType.TicketsResourceSecondaryBoard;
    this.route.queryParams.subscribe((params) => {
      if (params['view'] === 'by-mainboard') {
        this.selectedBoardType = this.boardType.HomePageResourceBoard;
      }
    });
    this.statusSearch.length = 0;
    this.newDates.length = 0;
    // Add takeUntil to subscription
    this.sharedParams.searchUserValue$
      .pipe(takeUntil(this.destroy$)) // Add this
      .subscribe((value) => {
        this.searchUser(value);
        this.searchResourceByName = value;
        this.searchResources(value);
      });

    if (
      this.selectedBoardType == this.boardType.TicketsResourceSecondaryBoard
    ) {
      const params = this.route.snapshot.queryParamMap;

      this.siteSearch = params.get('site');
      const statusParam = params.get('status');
      this.statusSearch = statusParam ? statusParam.split(',') : [];
      if(this.statusSearch.length == 0){
        this.isClearStatusFilters = true;
      }
      this.prioritySearch = params.get('priority');
      this.ProblemSearch = params.get('problem');
      this.facilitySearch = params.get('facility');
      this.areaSearch = params.get('area');
      this.startDate = params.get('start');
      this.endDate = params.get('end');
      this.startEntryDate = params.get('startentry');
      this.endEntryDate = params.get('endentry');
      const type = params.get('usertype') as ResourceType;
      this.selectedOption = type ?? ResourceType.ALL;
      this.userResourceFilter = type ?? ResourceType.ALL;
      if (this.selectedOption !== ResourceType.ALL) {
        this.sharedParams.setUserResourceValue(this.selectedOption);
        this.sharedParams.setUserSearchValue(this.searchResourceByName);
      }

      await this.siteService.fetchSite(
        true,
        this.facilityType,
        'network-only',
        null,
        this.filters
      );
      await this.busService.fetchBussinessLookupByCodeActAsParent(
        true,
        this.busLookupCodePriority
      );
      this.problemList = await this.busService.getLookupDataByParentModuleCode(
        this.busLookupCodeProblem
      );

      // Flatten parent-child into one list with parentName
      this.problemListAll = this.problemList
        .filter((parent) => parent.childLookup && parent.childLookup.length > 0) // Ensure parent has children
        .flatMap((parent) =>
          parent.childLookup.map((child) => ({
            id: child.id,
            name: child.name,
            parentName: parent.name,
          }))
        );

      if (this.facilitySearch) {
        this.onLoadFacility(this.facilitySearch);
        if (this.siteSearch) {
          this.onLoadLocation(this.siteSearch);
        }
      }
    }
    else{
      this.route.queryParams.subscribe((params) => {
      if (params['view'] !== 'by-ticket-count') {
        this.sharedParams.setUserResourceValue(null);
        this.sharedParams.setUserSearchValue(null);
      }
    });
    }

    // Set default view once

    this.expandedItems = this.UserTickets.map(() => false);
    this.communicationService.updateState(this.allExpanded);
    this.sharedParams.isComponentLoaded = true;

    this.statusList = await this.busService.getLookupDataByParentModuleCode(
      this.lookupModuleCOde
    );
    this.ranges = this.dateRangeUtilService.getPredefinedRanges();
    this.rangesEntry = this.dateRangeUtilService.getPredefinedRanges();
    if (!this.startDate || !this.endDate) {
      const defaultEntryRange = this.rangesEntry['Last 30 Days'];
      //Entry Date
      this.entryDate = {
        startDate: defaultEntryRange[0],
        endDate: defaultEntryRange[1],
      };
      this.startEntryDate = this.entryDate?.startDate;
      this.endEntryDate = this.entryDate?.endDate;
      // Due Date
      const defaultRange = this.ranges['Last 30 Days'];
      this.dueDate = {
        startDate: defaultRange[0],
        endDate: defaultRange[1],
      };
      this.startDate = this.dueDate?.startDate;
      this.endDate = this.dueDate?.endDate;
    } else {
      //Entry Date
      const parsedEntryStartDate = moment(this.startEntryDate);
      const parsedEntryEndDate = moment(this.endEntryDate);
      // Set Entry EndDate
      const adjustedEntryEnd = new Date(this.endEntryDate);
      adjustedEntryEnd.setDate(adjustedEntryEnd.getDate() - 1);

      this.entryDate = {
        startDate: parsedEntryStartDate,
        endDate: adjustedEntryEnd,
      };
      // Due Date
      const parsedStartDate = moment(this.startDate);
      const parsedEndDate = moment(this.endDate);
      // Set Due EndDate
      const adjustedEnd = new Date(this.endDate);
      adjustedEnd.setDate(adjustedEnd.getDate() - 1);

      this.dueDate = {
        startDate: parsedStartDate,
        endDate: adjustedEnd,
      };
    }
    if (
      (this.selectedBoardType == this.boardType.TicketsResourceSecondaryBoard ||
        this.selectedBoardType == this.boardType.HomePageResourceBoard)
    ) {
      this.statusListAll = this.statusList
        .filter((parent) => parent.childLookup && parent.childLookup.length > 0) // Ensure parent has children
        .flatMap((parent) =>
          parent.childLookup.map((child) => ({
            id: child.id,
            name: child.name,
            parentName: parent.name,
          }))
        );
      this.sharedParams.statusList = this.statusList;
      if(this.statusSearch.length > 0 && !this.isClearStatusFilters){

        this.statusIdsList = this.getStstusListWithoutComplete();
      }
      this.statusSearch = this.statusIdsList?.length>0? this.statusIdsList: this.statusSearch;
      this.statusIdsList = this.statusSearch;
    }

    setTimeout(async () => {
      await this.userRights();
      if (this.sharedParams.isComponentLoaded){
        this.getSharedFilterValues(this.ticketGridViewType.TICKET);
      }
    }, 1000);
    // Add takeUntil to this subscription too
    this.subscription = this.communicationService.expandCollapseEvent$
      .pipe(takeUntil(this.destroy$)) // Add this
      .subscribe(() => {
        this.toggleAll();
      });
  }

  getStstusListWithoutComplete() {
    return this.statusList
      .map(
        (parent) =>
          parent.childLookup
            ? parent.childLookup
                .filter(
                  (child) =>
                    // Exclude specific codes: 'COMPLT', lookupStatus.CANCEL and lookupStatus.HOLD
                    String(child.code) !== 'COMPLT' &&
                    String(child.code) !== String(lookupStatus.CANCEL) &&
                    String(child.code) !== String(lookupStatus.HOLD)
                )
                .map((child) => child.id) // Extract ids
            : [] // Return empty array if childLookup is undefined
      )
      .reduce((acc, val) => acc.concat(val), []); // Flatten the array
  }

  getWeekRange(dateStr: string) {
    const givenDate = new Date(dateStr);

    // Find Sunday (start of week)
    const startDate = new Date(givenDate);
    startDate.setDate(givenDate.getDate() - givenDate.getDay());

    // Find Saturday (end of week)
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);

    // Save as YYYY-MM-DD strings
    this.startDate = startDate.toISOString().split('T')[0];
    this.endDate = endDate.toISOString().split('T')[0];
  }

  async resourceCountTickets() {
    const userTicketsMap: Record<
      string,
      {
        ticketIds: Set<string>;
        tickets: Ticket[];
        pic: string;
        id: string; // <-- store user id
      }
    > = {};

    this.countTickets.data.forEach((ticket) => {
      ticket.ticketLabor.forEach((tick) => {
        const userName = tick.workerName;
        const pic = tick.workerPic;
        const workerId = tick.workerId; // <-- this is the user id

        if (workerId && userName) {
          if (!userTicketsMap[userName]) {
            userTicketsMap[userName] = {
              ticketIds: new Set(),
              tickets: [],
              pic,
              id: workerId,
            };
          }

          if (!userTicketsMap[userName].ticketIds.has(ticket.id)) {
            userTicketsMap[userName].tickets.push(ticket);
            userTicketsMap[userName].ticketIds.add(ticket.id);
          }

          // Always update pic + id (in case they change)
          userTicketsMap[userName].pic = pic;
          userTicketsMap[userName].id = workerId;
        }
      });
    });

    // Sort tickets for each user
    Object.values(userTicketsMap).forEach((data) => {
      data.tickets.sort((a, b) => {
        const orderCompare =
          (a.ticketCountDisplayOrder || 0) - (b.ticketCountDisplayOrder || 0);
        if (orderCompare !== 0) return orderCompare;

        // If order is same, compare by createdOn (descending)
        return (
          new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()
        );
      });
    });

    // Convert to array
    this.userAllTickets = Object.entries(userTicketsMap).map(
      ([userName, data]) => ({
        userName,
        tickets: data.tickets,
        pic: data.pic,
        id: data.id, // <-- include id here
      })
    );

    // Apply filter
    if (this.userResourceFilter === ResourceType.PRIMARY) {
      this.userAllTickets = this.userAllTickets
        .map((user) => ({
          ...user,
          tickets: user.tickets.filter((ticket) => {
            const latest = this.getLatestChangeStatus(ticket);
            return latest?.assignedUserId === user.id;
          }),
        }))
        .filter((user) => user.tickets.length > 0);
    } else if (this.userResourceFilter === ResourceType.SECONDARY) {
      this.userAllTickets = this.userAllTickets
        .map((user) => ({
          ...user,
          tickets: user.tickets.filter((ticket) => {
            const latest = this.getLatestChangeStatus(ticket);
            return latest?.assignedUserId !== user.id;
          }),
        }))
        .filter((user) => user.tickets.length > 0);
    }

    // Initialize with all tickets, sorted alphabetically
    this.filteredUserTicketsByCount = [...this.userAllTickets].sort((a, b) => {
      const aFirst = a.userName?.[0]?.toLowerCase() || '';
      const bFirst = b.userName?.[0]?.toLowerCase() || '';
      return aFirst.localeCompare(bFirst);
    });
  }

  getLatestChangeStatus(ticketChange: Ticket): TicketStatusChange | undefined {
    if (ticketChange?.ticketStatusChanges?.length > 0) {
      return ticketChange.ticketStatusChanges.reduce<
        TicketStatusChange | undefined
      >(
        (latest, change) => {
          if (!latest?.changeOn) return change;
          if (!change.changeOn) return latest;
          return new Date(latest.changeOn) > new Date(change.changeOn)
            ? latest
            : change;
        },
        undefined // initial value
      );
    }
    return undefined;
  }

  getProgressColor(percentage: number): string {
    if (percentage > 100) {
      return '#C10007'; // red
    } else if (percentage === 100 || percentage >= 90) {
      return '#00B050'; // green
    } else {
      return '#FFD301'; // Yellow lik color (you can pick another color)
    }
  }

  async drop(event: CdkDragDrop<Ticket[]>, tickets: { tickets: Ticket[] }) {
    // Only if dropped inside the same user's ticket list
    if (event.previousContainer === event.container) {
      if (event.previousIndex !== event.currentIndex) {
        // Reorder tickets locally
        moveItemInArray(
          tickets.tickets,
          event.previousIndex,
          event.currentIndex
        );

        // Build payload for API
        const updateTicketOrder: UpdateTicketOrder = {
          tickets: tickets.tickets.map((ticket, index) => ({
            id: ticket.id!,
            order: index + 1,
          })),
        };

        try {
          await this.service.updateTicketOrder(updateTicketOrder);
          this.countTickets.data = this.countTickets.data.map((ticket) => {
            const update = updateTicketOrder.tickets.find(
              (u) => u.id === ticket.id
            );
            return update
              ? { ...ticket, ticketCountDisplayOrder: update.order } // clone + update
              : ticket;
          });

          this.clearData();
          await this.resourceCountTickets();
          this.searchUser(this.searchResourceByName);
        } catch (err) {
          console.error('Failed to update order', err);
        }
      }
    }
  }

  searchUser(value: string) {
    const searchValue = value?.toLowerCase() || '';

    this.filteredUserTicketsByCount = this.userAllTickets
      .filter((user) => user.userName?.toLowerCase().includes(searchValue))
      .sort((a, b) =>
        (a.userName?.[0] || '')
          .toLowerCase()
          .localeCompare((b.userName?.[0] || '').toLowerCase())
      );
  }

  getTotalEstimatedWeekHours(userObj: User): number {
    let total = 0;

    this.newDates.forEach((day) => {
      total += this.calculateEstimatedHours(userObj, day.day);
    });

    return total;
  }

  getAvailableWeekHours(userObj) {
    let total = 0;

    this.newDates.forEach((day) => {
      total += this.getAvailableHours(userObj, day.day);
    });

    return total;
  }

  getAvailableHours(userObj, weekDay) {
    let totalHours = 0;

    const dayTickets = userObj.day[weekDay] || [];

    dayTickets.forEach((ticket) => {
      (ticket.ticketLabor || []).forEach((labor) => {
        if (labor.hoursType === LaborRateType.Regular) {
          totalHours += labor.hours || 0;
        }
      });
    });
    return totalHours;
  }

  calculateEstimatedHours(userObj, weekDay) {
    let totalHours = 0;

    const dayTickets = userObj.day[weekDay] || [];

    dayTickets.forEach((ticket) => {
      (ticket.ticketLabor || []).forEach((labor) => {
        totalHours += labor.estimated || 0;
      });
    });

    return totalHours;
  }

  getPercentage(value) {
    return value;
  }

  getTicketsByDay(dateStr: string, ticketObject: Ticket[]): Ticket[] {
    return ticketObject.filter((ticket) => {
      if (!ticket.entryDate) return false;
      const currentDate = ticket.entryDate.toString().split(' ')[0];
      return currentDate == dateStr;
    });
  }

  async LoadData() {
    this.clearData();
    const res = await firstValueFrom(this.uService.users$);
    res.data.forEach((site) => this.Users.push({ siteId: site.id }));
    await this.getData('network-only');
    await this.resourceCountTickets();
  }

  clearData() {
    // Call correct function based on active tab
    this.UserTickets.length = 0;
    this.FilteredUserTickets.length = 0;
    this.ShowTickets.length = 0;
    this.Users.length = 0;
    this.userAllTickets.length = 0;
    this.allTickets.length = 0;
    this.filteredUserTicketsByCount.length = 0;
  }

  getWeekDates(referenceDate?: string | Date): Date[] {
    const today = referenceDate ? new Date(referenceDate) : new Date();
    const dayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)

    // Calculate the date of the Sunday for the given week
    const sunday = new Date(today);
    sunday.setDate(today.getDate() - dayOfWeek);

    // Collect all 7 days from Sunday to Saturday
    const weekDates: Date[] = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(sunday);
      date.setDate(sunday.getDate() + i);
      weekDates.push(date);
    }

    return weekDates;
  }

  //Search the Resources in the Show Tickets Model
  searchResources(value: string) {
    if (!value) {
      this.ShowTickets = [...this.allTickets]; // Reset or keep as is if empty search
      return;
    }
    const searchValue = value.toLowerCase();
    this.ShowTickets = this.allTickets.filter(
      (ticketUser) =>
        ticketUser.userName &&
        ticketUser.userName.toLowerCase().includes(searchValue)
    );
  }

  getDialogDimensionsTicketDetailPopup(): {
    maxHeight: string;
    width: string;
    height: string;
  } {
    const windowWidth = window.innerWidth;

    if (windowWidth < 1030) {
      return { width: '94vw', height: '760px', maxHeight: '98vh' };
    } else {
      return { width: '1160px', height: '98vh', maxHeight: '98vh' };
    }
  }

  ticketDetail(ticketId: string) {
    const { width, height, maxHeight } =
      this.getDialogDimensionsTicketDetailPopup();

    const dialog = this.dialog.open(TicketDetailPopupComponent, {
      minWidth: width,
      width: width,
      height: height,
      maxHeight: maxHeight,
      panelClass: 'center-popup',
      hasBackdrop: true,
      data: {
        id: ticketId,
      },
      disableClose: true,
    });

    // ✅ When dialog opens → add "id" param but keep existing ones
    dialog.afterOpened().subscribe(() => {
      this.sharedParams.isComponentLoaded = false;
      this.isDialogOpened = true;
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { id: ticketId },
        queryParamsHandling: 'merge', // <-- merge instead of replace
      });
    });

    // ✅ When dialog closes → remove "id" but keep other params
    dialog.afterClosed().subscribe(async (result) => {
      this.params = null;
      this.isDialogOpened = false;

      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { id: null }, // <-- clear only "id"
        queryParamsHandling: 'merge', // <-- keep "view=by-ticket-count"
      });

      if (result == 1) {
        this.loading = true;
        await this.LoadData();
        this.loading = false;
      }
    });
  }

  trackByTicketId(index: number, item: Ticket) {
    return item.id;
  }

  async resourceHoursTickets() {
    this.UserTickets = [];

    // ✅ Build userTickets directly from ticket data (not just this.Users)
    this.hourTickets.data.forEach((ticket) => {
      ticket.ticketLabor.forEach((tick) => {
        if (tick.workerId && tick.workerName) {
          this.UserTickets.push(ticket);
        }
      });
    });

    // ✅ Step 1: Filter tickets that have at least one ticketLocationMap entry
    this.FilteredUserTickets = this.UserTickets.filter(
      (loc) => loc.ticketLocationMap.length > 0
    );

    // ✅ Step 2: Get unique userNames from ticketLabor
    const uniqueUserNames = [
      ...new Set(
        this.FilteredUserTickets.flatMap(
          (ticket) =>
            ticket.ticketLabor?.map((labMap) => labMap.workerName) || []
        ).filter((name) => !!name)
      ),
    ];
    // ✅ Step 3: Build ShowTickets array
    this.ShowTickets = uniqueUserNames.map((userName) => {
      // Collect all tickets for this user (unique by ID)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const ticketMap = new Map<string, any>();

      this.FilteredUserTickets.forEach((ticket) => {
        const hasUser = ticket.ticketLabor?.some(
          (labMap) => labMap.workerName === userName
        );

        if (hasUser && !ticketMap.has(ticket.id)) {
          ticketMap.set(ticket.id, ticket);
        }
      });

      const matchingTickets = Array.from(ticketMap.values());
      // Build day-wise grouping
      const day: Record<string, Ticket[]> = {};

      this.newDates.forEach((weekday) => {
        const key = weekday.day; // temporary variable
        day[key] = this.getTicketsByDay(weekday.date, matchingTickets);
      });

      return {
        userName,
        day,
      };
    });
    // ✅ Step 4: Remove users with no tickets across all weekdays
    this.ShowTickets = this.ShowTickets.filter((ticketUser) =>
      Object.values(ticketUser.day).some(
        (tickets) => (tickets as Ticket[]).length > 0
      )
    );

    this.allTickets = this.ShowTickets;
  }

  // eslint-disable-next-line
  calculateTicketLengths(user: any): number {
    if (!user?.day) return 0;

    return Object.values(user.day)
      .filter((dayArr) => Array.isArray(dayArr))
      .reduce((sum, dayArr) => sum + dayArr.length, 0);
  }

  async getData(policy: FetchPolicy = null) {
    if(!this.startDate || !this.startEntryDate) return;
    this.countTickets = await this.service.getPaginatedTicketsGrid(
      this.filters,
      null,
      this.workerId,
      null,
      policy,
      this.siteSearch,
      this.statusSearch,
      this.prioritySearch,
      this.ProblemSearch,
      this.facilitySearch,
      this.areaSearch,
      this.sortInput,
      this.startDate,
      this.endDate,
      'TKT',
      null,
      null,
      null,
      null,
      this.startEntryDate,
      this.endEntryDate
    );
    if (this.countTickets.data) {
      const ids: string[] = this.countTickets.data.map((t) => t.id!);

      // fetch related entities
      const [labors, statusChanges] = await Promise.all([
        this.laborService.getTicketLaborsByTicketIds(ids),
        this.statusChangeService.getTicketStatusChangeByTicketIds(ids),
      ]);
      // group labors by ticketId
      const laborMap = new Map<string, TicketLabor[]>();
      labors.forEach((l) => {
        if (!laborMap.has(l.ticketId!)) {
          laborMap.set(l.ticketId!, []);
        }
        laborMap.get(l.ticketId!)!.push(l);
      });

      // group statusChanges by ticketId
      const statusMap = new Map<string, TicketsStatusChange[]>();
      statusChanges.forEach((sc) => {
        if (!statusMap.has(sc.ticketId!)) {
          statusMap.set(sc.ticketId!, []);
        }
        statusMap.get(sc.ticketId!)!.push(sc);
      });
      const locationIds: string[] = [
        ...new Set(
          this.countTickets.data.flatMap((t) =>
            t.ticketLocationMap.map((l) => l.locationId)
          )
        ),
      ];
      const [locations] = await Promise.all([
        this.siteService.getSitesByIds(locationIds, SiteType.LOCATION),
      ]);
      this.siteList = locations;
      this.countTickets.data.forEach((ticket) => {
        this.ticketLocationsMap[ticket.id] =
          this.getTicketLocationsWithAreas(ticket);
      });
      // embed into tickets
      this.countTickets.data = this.countTickets.data.map((ticket) => ({
        ...ticket,
        ticketLabor: laborMap.get(ticket.id!) || [],
        ticketStatusChanges: statusMap.get(ticket.id!) || [],
      }));
    }
  }

  userRights() {
    this.isManager = this.authService.hasPermission(AppPermissions.TicketWrite);
    //
    this.ViewAllTicketsRead = this.authService.hasPermission(
      AppPermissions.ViewAllTicketsRead
    );
    this.ViewAllTicketsWrite = this.authService.hasPermission(
      AppPermissions.ViewAllTicketsWrite
    );
    //
    this.TicketResourcesBoardRead = this.authService.hasPermission(
      AppPermissions.TicketResourcesBoardRead
    );
    this.TicketResourcesBoardWrite = this.authService.hasPermission(
      AppPermissions.TicketResourcesBoardWrite
    );
    //
  }

  openSecondaryDisplay() {
    if ('getScreenDetails' in window) {
      (window as any).getScreenDetails().then((screenDetails: any) => {
        let secondScreen =
          screenDetails.screens.length > 1
            ? screenDetails.screens[1]
            : screenDetails.screens[0];

        const features = [
          `left=${secondScreen.availLeft}`,
          `top=${secondScreen.availTop}`,
          `width=${secondScreen.width}`,
          `height=${secondScreen.height}`,
          'fullscreen=yes',
          'titlebar=no',
          'toolbar=no',
          'menubar=no',
          'status=no',
          'location=no',
          'resizable=yes',
          'scrollbars=no',
        ].join(',');

        // 👇 pass params through URL
        // Ensure all params are strings (URLSearchParams expects string values)
        const statusVal: string = Array.isArray(this.statusSearch)
          ? this.statusSearch.join(',')
          : this.statusSearch ?? '';

        // const userVal: string = typeof this.sharedParams.userResourceValue === 'string'
        //   ? this.sharedParams.userResourceValue
        //   : (this.sharedParams.userResourceValue != null ? String(this.sharedParams.userResourceValue) : '');
        const query = new URLSearchParams({
          site: this.siteSearch ?? '',
          status: statusVal,
          priority: this.prioritySearch ?? '',
          problem: this.ProblemSearch ?? '',
          facility: this.facilitySearch ?? '',
          area: this.areaSearch ?? '',
          start: this.startDate,
          end: this.endDate,
          startentry: this.startEntryDate,
          endentry: this.endEntryDate,
          usertype: this.selectedOption
          // user: userVal
        }).toString();

        const url = `/resource/board?${query}`;

        const newWindow = window.open(url, 'SecondaryDisplay', features);

        if (newWindow) {
          newWindow.focus();
          newWindow.moveTo(secondScreen.availLeft, secondScreen.availTop);
          newWindow.resizeTo(secondScreen.width, secondScreen.height);

          newWindow.onload = () => {
            newWindow.document.documentElement.requestFullscreen?.();
            // 🔥 Send data to the new window

            //           const payload = {
            //   siteSearchInput: this.sharedService.siteSearch ?? null,
            //   statusSearchInput: this.sharedService.statusSearch ?? null,
            //   prioritySearchInput: this.sharedService.prioritySearch ?? null,
            //   ProblemSearchInput: this.sharedService.ProblemSearch ?? null,
            //   facilitySearchInput: this.sharedService.facilitySearch ?? null,
            //   areaSearchInput: this.sharedService.areaSearch ?? null,
            //   startDateInput: this.sharedService.startDateSearch ?? null,
            //   endDateInput: this.sharedService.endDateSearch ?? null,
            //   searchBynameInput: this.sharedService.userResourceValue ?? null
            // };

            //           const safePayload = JSON.parse(JSON.stringify(payload));
            //           const msg = {
            //   type: "RESOURCE_BOARD_DATA",
            //   payload: safePayload
            // };

            // newWindow.postMessage(msg, window.location.origin);

            // // Send again after Angular bootstraps
            // setTimeout(() => newWindow.postMessage(msg, window.location.origin), 700);
          };
        }
      });
    }
  }

  // ngAfterViewInit() {
  //   console.log('ViewChildren:', this.carouselRefs);
  //     // Try to request fullscreen once page has loaded
  //     setTimeout(() => {
  //       const el = document.documentElement as any;
  //       if (el.requestFullscreen) {
  //         el.requestFullscreen().catch(() => {});
  //       } else if (el.webkitRequestFullscreen) { // Safari
  //         el.webkitRequestFullscreen();
  //       } else if (el.msRequestFullscreen) { // IE11
  //         el.msRequestFullscreen();
  //       }
  //     }, 300);

  // }
  applyDateRangeFilter() {
    this.searchResourceByName = '';
    this.sharedParams.isComponentLoaded = true;

    this.applyRangeFilter();
  }
  async applyRangeFilter() {
    this.dropdownService.hideAllDropdowns();

    if (this.dueDate?.startDate && this.dueDate?.endDate) {
      //Convert endDate into Date object and subtract 1 day
      const adjustedEnd = new Date(this.dueDate?.endDate);
      adjustedEnd.setDate(adjustedEnd.getDate() - 1);
      //
      const adjustedEntryEnd = new Date(this.entryDate?.endDate);
      adjustedEntryEnd.setDate(adjustedEntryEnd.getDate() - 1);
      //Entry Date
    this.startEntryDate = this.entryDate?.startDate;
    this.endEntryDate = adjustedEntryEnd.toString();
    //Due Date
    this.startDate = this.dueDate?.startDate;
    this.endDate = adjustedEnd.toString();
    this.getSharedFilterValues(1);
    }

  }
  SetDialogWidth(): string {
    let returnWidth;
    const windowWidth = window.innerWidth;
    switch (true) {
      case windowWidth < 450: {
        returnWidth = '94vw';
        break;
      }
      case windowWidth >= 450 && windowWidth < 750: {
        returnWidth = '94vw';
        break;
      }
      default:
        returnWidth = '1160px';
    }
    return returnWidth;
  }

  toggle(index: number) {
    this.expandedItems[index] = !this.expandedItems[index];
    this.allExpanded = this.expandedItems.every((v) => v);
    this.communicationService.updateState(this.allExpanded);
  }

  toggleAll() {
    this.allExpanded = !this.allExpanded;
    this.expandedItems = this.UserTickets.map(() => this.allExpanded);
    this.communicationService.updateState(this.allExpanded); // update state
  }

  isExpanded(i: number): boolean {
    return this.expandedItems[i];
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscription?.unsubscribe();
  }
  getTagStyle(index: number): string {
    const i = index % 3; // ensures 0,1,2
    switch (i) {
      case 0:
        return 'bg-[#FEFCE8] border border-[#FEF9C2]';
      case 1:
        return 'bg-[#FEF2F2] border border-[#FFE2E2]';
      case 2:
      default:
        return 'bg-[#F0FDF4] border border-[#B9F8CF]';
    }
  }

  getTotalEstimatedHours(ticket: Ticket): number {
    if (!ticket?.ticketLabor || !Array.isArray(ticket.ticketLabor)) return 0;

    return ticket.ticketLabor.reduce((acc: number, labor) => {
      return acc + (labor.estimated || 0);
    }, 0);
  }
  getTotalRegularHours(ticket: Ticket): number {
    if (!ticket?.ticketLabor || !Array.isArray(ticket.ticketLabor)) return 0;

    return ticket.ticketLabor.reduce((acc: number, labor) => {
      if (labor.hoursType === 'REGULAR') {
        return acc + (labor.hours || 0);
      }

      return acc; // ← missing before!
    }, 0);
  }
  getTotalBillableHours(ticket: Ticket): number {
    if (!ticket?.ticketLabor || !Array.isArray(ticket.ticketLabor)) return 0;

    return ticket.ticketLabor.reduce((acc: number, labor) => {
      if (labor.hoursType === 'REGULAR') {
        return acc + (labor.billable || 0);
      }

      return acc; // ← missing before!
    }, 0);
  }

  async onChangeUser() {
    // this.sharedParams.setUserResourceValue(this.selectedOption);
    // if (this.searchResourceByName)
    //   this.sharedParams.setUserSearchValue(this.searchResourceByName);
  }

  onSearchUsers(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.searchResourceByName = value;
    this.sharedParams.setUserSearchValue(value); // or whatever logic
  }
  toggleDropdown(id: string, event: MouseEvent): void {
    event.stopPropagation();
    if (this.duePicker?.picker?.isShown) {
    this.duePicker.hide();
  }
  if (this.startPicker?.picker?.isShown) {
    this.startPicker.hide();
  }
    this.dropdownService.toggleDropdown(id);
  }

  // Check if a dropdown is visible
  isDropdownVisible(id: string): boolean {
    return this.dropdownService.isDropdownVisible(id);
  }

  onDivClick(event: MouseEvent): void {
    event.stopPropagation(); // Prevent document click listener from closing dropdown
  }

  async onChangePriority(event: string) {
    this.prioritySearch = event;
  }

  async onChangeProblem(event: string) {
    this.ProblemSearch = event;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async onChangeStatus(event: any) {
    this.statusSearch = event;
    this.isClearStatusFilters = false;
    if(this.statusSearch.length == 0){
      this.isClearStatusFilters = true;
    }
  }

  async onChangeFacility(event: string) {
    ;
    const isCleared = !event || (Array.isArray(event) && event.length === 0);
    if (isCleared) {
      this.clearFacilityRelatedFields();
      this.cdr.detectChanges();
      return;
    }

    this.clearFacilityRelatedFields();
    this.fcSearch = Array.isArray(event) ? event : [event];
    this.facilitySearch = event;
    this.isCallLocationRefresh = true;

    this.siteService.fetchSiteByParent(
      true,
      this.siteType,
      'network-only',
      this.fcSearch,
      this.siteSortInput
    );
  }

  private clearFacilityRelatedFields() {
    this.facilitySearch = '';
    this.areaSearch = '';
    this.fcSearch = null;
    // 🔴 Clear location
    this.siteService.siteChild$ = of({
      data: [],
      pageInfo: {
        hasNextPage: false,
        hasPreviousPage: false,
        startCursor: null,
        endCursor: null,
      },
      totalCount: 0,
      errors: [],
    } as unknown as PageResult<Site>);

    this.siteSearch = '';
    this.stSearch = null;
    // 🔴 Clear areaChild$ observable (area dropdown options)
    this.siteService.areaChild$ = of({
      data: [],
      pageInfo: {
        hasNextPage: false,
        hasPreviousPage: false,
        startCursor: null,
        endCursor: null,
      },
      totalCount: 0,
      errors: [],
    } as unknown as PageResult<Site>);
  }

  async onChangeLocation(event: string) {
    // 🔴 If location dropdown is cleared
    if (!event || (Array.isArray(event) && event.length === 0)) {
      this.clearLocationRelatedFields();
      // ✅ Trigger change detection so UI refreshes while open
      this.cdr.detectChanges();
      return;
    }
    this.clearLocationRelatedFields();

    this.stSearch = [event];
    this.selectedSiteType = this.areaType;
    this.isCallAreaRefresh = true;
    this.siteSearch = event;

    this.siteService.fetchSiteByParent(
      true,
      this.selectedSiteType,
      'network-only',
      this.stSearch,
      this.siteSortInput
    );
  }

  clearLocationRelatedFields() {
    this.siteSearch = '';
    this.areaSearch = '';
    this.stSearch = [];
    // 🔴 Clear areaChild$ observable (area dropdown options)
    this.siteService.areaChild$ = of({
      data: [],
      pageInfo: {
        hasNextPage: false,
        hasPreviousPage: false,
        startCursor: null,
        endCursor: null,
      },
      totalCount: 0,
      errors: [],
    } as unknown as PageResult<Site>);
  }

  async onChangeArea(event: string) {
    this.areaSearch = event;
  }
  //OnLoad
  async onLoadFacility(event: string) {
    ;
    this.fcSearch = Array.isArray(event) ? event : [event];
    this.facilitySearch = event;
    this.isCallLocationRefresh = true;

    this.siteService.fetchSiteByParent(
      true,
      this.siteType,
      'network-only',
      this.fcSearch,
      this.siteSortInput
    );
  }

  async onLoadLocation(event: string) {
    // 🔴 If location dropdown is cleared

    this.stSearch = [event];
    this.selectedSiteType = this.areaType;
    this.isCallAreaRefresh = true;
    this.siteSearch = event;

    this.siteService.fetchSiteByParent(
      true,
      this.selectedSiteType,
      'network-only',
      this.stSearch,
      this.siteSortInput
    );
  }

  clearFilters() {
    this.facilitySearch = '';
    this.fcSearch = null;
    this.clearFacilityRelatedFields();
    this.selectedOption = ResourceType.ALL;
    this.siteSearch = '';
    this.areaSearch = '';
    this.prioritySearch = '';
    this.ProblemSearch = '';
    this.isClearStatusFilters = false;
    this.statusListAll = this.statusList
      .filter((parent) => parent.childLookup && parent.childLookup.length > 0)
      .flatMap((parent) =>
        parent.childLookup.map((child) => ({
          id: child.id,
          name: child.name,
          parentName: parent.name,
        }))
      );

    // ✅ Select ALL statuses again
    this.statusIdsList = this.getStstusListWithoutComplete();
        this.statusSearch = this.statusIdsList?.length>0? this.statusIdsList: this.statusSearch;
      //
    // Optionally trigger change handler so UI updates
    this.onChangeStatus(this.statusIdsList);
    const defaultEntryRange = this.rangesEntry['Last 30 Days'];
    //entryDate
    this.entryDate = {
      startDate: defaultEntryRange[0],
      endDate: defaultEntryRange[1],
    };
    this.startEntryDate = this.entryDate?.startDate;
    this.endEntryDate = this.entryDate?.endDate;
    //Due Date
    const defaultRange = this.ranges['Last 30 Days'];
    this.dueDate = {
      startDate: defaultRange[0],
      endDate: defaultRange[1],
    };
    this.startDate = this.dueDate?.startDate;
    this.endDate = this.dueDate?.endDate;
  }

  async applyFilters() {
    this.dropdownService.hideAllDropdowns();
    this.sharedParams.setUserResourceValue(this.selectedOption);
    if (this.searchResourceByName)
      this.sharedParams.setUserSearchValue(this.searchResourceByName);
    this.getSharedFilterValues(1);
  }

  @HostListener('document:click')
  async onDocumentClick() {
    this.dropdownService.hideAllDropdowns();
  }

  getTicketLocationsWithAreas(
    ticket: Ticket
  ): { location: Site; areas: Site[] }[] {
    if (!ticket.ticketLocationMap) return [];

    return ticket.ticketLocationMap
      .map((lm) => {
        const location = this.siteList.find((s) => s.id === lm.locationId);
        if (!location) return null;

        // filter only the child areas that belong to this ticket
        const selectedAreaIds =
          ticket.ticketAreaMap?.map((am) => am.areaId) || [];
        const selectedAreas = location.childSite.filter((c) =>
          selectedAreaIds.includes(c.id)
        );

        return { location, areas: selectedAreas };
      })
      .filter((x): x is { location: Site; areas: Site[] } => !!x);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getTicketAreaNames(loc: any): string {
    return loc.areas?.map((a) => a.name).join(', ') ?? '';
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getRemainingAreasTooltip(loc: any): string {
    if (loc.areas?.length <= 1) return '';

    const remaining = loc.areas?.slice(1);
    const areas = remaining
      .map((a) => {
        const areaNames = a.name;
        return `${areaNames}`;
      })
      .join('\n , '); // newline → handled by .multiline-tooltip
    return areas;
  }

  getRemainingLocationsTooltip(ticket: Ticket): string {
    const all = this.getTicketLocationsWithAreas(ticket);
    if (all.length <= 1) return '';

    const remaining = all.slice(1);
    return remaining
      .map((loc) => {
        const areaNames = loc.areas.map((a) => a.name).join(', ');
        return `${loc.location.name} [ ${areaNames} ]`;
      })
      .join('\n'); // newline → handled by .multiline-tooltip
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getFirstTwoAreaNames(loc: any): string {
    if (!loc.areas?.length) return '';
    const visible = loc.areas.slice(0, 1).map((a) => a.name);
    return visible.join(', ');
  }

  // Sort areas by first letter of name in ascending order, then by number
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSortedAreas(loc: any): any[] {
    if (!loc?.areas || !Array.isArray(loc.areas)) return [];
    return [...loc.areas].sort((a, b) => {
      const aName = (a.name || '').trim();
      const bName = (b.name || '').trim();

      // Extract first letter (case-insensitive)
      const aFirst = aName.charAt(0).toLowerCase();
      const bFirst = bName.charAt(0).toLowerCase();

      // Compare by first letter first
      const letterCompare = aFirst.localeCompare(bFirst);
      if (letterCompare !== 0) {
        return letterCompare;
      }

      // If letters are the same, extract and compare numbers
      const aNumberMatch = aName.substring(1).match(/^\d+/);
      const bNumberMatch = bName.substring(1).match(/^\d+/);

      const aNumber = aNumberMatch ? parseInt(aNumberMatch[0], 10) : 0;
      const bNumber = bNumberMatch ? parseInt(bNumberMatch[0], 10) : 0;

      return aNumber - bNumber;
    });
  }


  getSortedLocations(locations: any[]): any[] {
    if (!locations || !Array.isArray(locations)) return [];

    return [...locations].sort((a, b) => {
      const nameA = a.location?.name || '';
      const nameB = b.location?.name || '';

      // Extract letters
      const lettersA = nameA.match(/[a-zA-Z]+/)?.[0].toLowerCase() || '';
      const lettersB = nameB.match(/[a-zA-Z]+/)?.[0].toLowerCase() || '';

      // 1️⃣ Sort by letters
      if (lettersA !== lettersB) return lettersA.localeCompare(lettersB);

      // Extract numbers
      const numberA = parseInt(nameA.match(/\d+/)?.[0] || '0', 10);
      const numberB = parseInt(nameB.match(/\d+/)?.[0] || '0', 10);

      // 2️⃣ Sort by numbers
      return numberA - numberB;
    });
  }


}
